import { FC, useLayoutEffect, useRef, useState } from "react";
import { ZTooltip } from "../ZTooltip/ZTooltip";

interface TruncatedTextProps {
  text: string;
  className?: string;
}

const TruncatedText: FC<TruncatedTextProps> = ({ text, className }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    if (textRef.current) {
      const { clientHeight, scrollHeight } = textRef.current;
      setIsTruncated(scrollHeight > clientHeight);
    }
  }, [text, textRef.current]);


  return (
    <ZTooltip showArrow content={<div className="max-w-[30rem] break-words">{text}</div>} isDisabled={!isTruncated}
    >
      <div className={`flex ${className}`} data-fullname={text}>

        <div ref={textRef} className="truncate-one-line break-all">
          {text}
        </div>
      </div>
    </ZTooltip>
  );
};

export default TruncatedText;
